import { CardHeading } from "../../../../src/components/article-elements/CardHeading.tsx";
import * as React from 'react';
export default {
  CardHeading,
  React
};